"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _excluded = ["automationid", "children", "dataMetrics", "isFocused", "onClick", "onKeyDown", "route"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      '&:focus': {
        outline: 'none'
      },
      textDecoration: 'none'
    }
  };
});
var SidenavLink = function SidenavLink(props) {
  var automationid = props.automationid,
    children = props.children,
    dataMetrics = props.dataMetrics,
    isFocused = props.isFocused,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    route = props.route,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var classes = useStyles();
  var inputEl = (0, _react.useRef)(null);
  /**
   * This allows the autofocus for keyboard navigation
   */
  (0, _react.useEffect)(function () {
    if (isFocused) {
      inputEl.current.focus();
    }
  }, [isFocused]);
  var handleOnFocus = function handleOnFocus(event) {
    /**
     * ***** IMPORTANT do not remove this as it will trigger the menu to reset onfocus
     */
    event.stopPropagation();
  };
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({
    "automation-id": automationid,
    className: classes.root,
    "data-metrics": dataMetrics,
    onClick: onClick,
    onFocus: handleOnFocus,
    onKeyDown: onKeyDown,
    ref: inputEl,
    tabIndex: -1,
    to: route
  }, rest), children);
};
SidenavLink.defaultProps = {
  children: null,
  onClick: function onClick() {
    return null;
  },
  route: ''
};
SidenavLink.propTypes = process.env.NODE_ENV !== "production" ? {
  automationid: _propTypes["default"].string,
  /**
   * Content inside the link
   */
  children: _propTypes["default"].node,
  dataMetrics: _propTypes["default"].string,
  /**
   * if it is the current selected tab for focus styles
   */
  isFocused: _propTypes["default"].bool,
  /**
   * Callback function when lick has keydown event
   */
  onClick: _propTypes["default"].func,
  /**
   * The link's route
   */
  onKeyDown: _propTypes["default"].func,
  /**
   * Callback function when link is clicked
   */
  route: _propTypes["default"].string
} : {};
var _default = SidenavLink;
exports["default"] = _default;